import React, { lazy, } from 'react';
import { Navigate, } from 'react-router-dom';

const CreatePassword = lazy(() => import('../screens/CreatePassword'));
const ForgotPassword = lazy(() => import('../screens/ForgotPassword'));
const AccountVerificationOTP = lazy(() => import('../screens/AccountVerificationOTP'));
const SCLoginForm = lazy(() => import('../screens/SC/LoginForm'));
const PrivacyPolicy = lazy(() => import('../screens/PrivacyPolicy'));
const SCSwitchClientCompanyForm = lazy(() => import('../screens/SC/SwitchClientCompanyForm'));
const PublicThreadDetail = lazy(() => import('../screens/PublicThreadDetail'));
const PublicPostDetail = lazy(() => import('../screens/PublicPostDetail'));
const NotFound = lazy(() => import('../screens/NotFound'));
const LoginForm = lazy(() => import('../screens/LoginForm'));
const DeviceDeliveryConfirmation = lazy(() => import('../screens/DeviceDeliveryConfirmation'));

const publicRoutes = [
  {
    element: <LoginForm />,
    path: "/login",
    redirectWhenHasSession: true,
  },
  {
    element: <Navigate to="/login" replace />,
    path: "/",
    redirectWhenHasSession: true,
  },
  {
    element: <CreatePassword />,
    path: "account/create_password/:token",
  },
  {
    element: <CreatePassword />,
    path: "account/forgot_password/:token",
  },
  {
    element: <ForgotPassword />,
    path: "account/forgot_password",
  },
  {
    element: <AccountVerificationOTP />,
    path: "account/verify_otp",
  },
  {
    element: <SCLoginForm />,
    path: "/login/sc",
    redirectWhenHasSession: true,
  },
  {
    element: <SCSwitchClientCompanyForm />,
    path: "/switch_client_company/sc",
    accessKey: "always_show",
  },
  {
    element: <PublicThreadDetail />,
    path: "/threads/public/thread",
  },
  {
    element: <PublicPostDetail />,
    path: "/threads/public/post",
  },
  {
    element: <PrivacyPolicy />,
    path: "/privacy_policy",
  },
  {
    element: <DeviceDeliveryConfirmation />,
    path: "/device_delivery/received",
  },
  {
    path: "*",
    element: <NotFound />
  }
];

export default publicRoutes;

